export default function useHorizonAuth() {
  const {isAdmin} = useAuth()
  const {$customFetch} = useNuxtApp()

  async function openHorizonDashboard() {
    if (!isAdmin.value) {
      console.error("You don't have permission to access Horizon dashboard")
      return
    }

    const {url} = await $customFetch<{ url: string }>('/api/horizon-token')
    window.open(url, '_blank')
  }

  async function redirectToHorizon() {
    const {url} = await $customFetch<{ url: string }>('/api/horizon-token')
    window.location.replace(url)
  }

  return {
    openHorizonDashboard,
    redirectToHorizon,
  }
}
